export default __webpack_public_path__ + "static/media/chef.f62e46fd.png";